var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: { bottom: "", "z-index": "600" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            return [
              _c(
                "v-chip",
                _vm._g(
                  { attrs: { color: _vm.color, "text-color": _vm.textColor } },
                  on
                ),
                [
                  _c("v-icon", { staticClass: "small mr-1 my-2" }, [
                    _vm._v("fa-hotel")
                  ]),
                  _vm._v(_vm._s(_vm.text))
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "div",
        [
          _c("h2", [
            _vm._v(
              _vm._s(_vm.$t("travelService.types.hotel")) +
                " (" +
                _vm._s(_vm.$t("global.request")) +
                ")"
            )
          ]),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.roomType")) +
              ": " +
              _vm._s(_vm.roomTypeText)
          ),
          _c("br"),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.place")) +
              ": " +
              _vm._s(_vm.placeText)
          ),
          _c("br"),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.accommodationDate")) +
              ": " +
              _vm._s(_vm.travelServiceOrderItem.hotel.start_date) +
              " " +
              _vm._s(_vm.travelServiceOrderItem.hotel.start_time)
          ),
          _c("br"),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.outDate")) +
              ": " +
              _vm._s(_vm.travelServiceOrderItem.hotel.end_date)
          ),
          _c("br"),
          _vm._v(" " + _vm._s(_vm.$t("global.breakfast")) + " "),
          _vm.travelServiceOrderItem.hotel.is_breakfast === 1
            ? _c("v-icon", { attrs: { small: "", color: "success" } }, [
                _vm._v("fa-check")
              ])
            : _c("v-icon", { attrs: { small: "", color: "error" } }, [
                _vm._v("fa-times")
              ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" " + _vm._s(_vm.$t("travelService.isParkingRequired")) + " "),
          _vm.travelServiceOrderItem.hotel.parking_required === 1
            ? _c("v-icon", { attrs: { small: "", color: "success" } }, [
                _vm._v("fa-check")
              ])
            : _c("v-icon", { attrs: { small: "", color: "error" } }, [
                _vm._v("fa-times")
              ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            " " +
              _vm._s(_vm.$t("travelService.isFreeCancellationRequired")) +
              " "
          ),
          _vm.travelServiceOrderItem.hotel.is_free_cancellation === 1
            ? _c("v-icon", { attrs: { small: "", color: "success" } }, [
                _vm._v("fa-check")
              ])
            : _c("v-icon", { attrs: { small: "", color: "error" } }, [
                _vm._v("fa-times")
              ]),
          _vm._v(" "),
          _c("br")
        ],
        1
      ),
      _c("travel-service-order-item-common-tooltip-part", {
        attrs: { "travel-service-order-item": _vm.travelServiceOrderItem }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }